import { useCanvasElementsObjects } from "frontend/subscriptions";
import { useAtomValue } from "jotai";
import { intersection, KeyValuePair } from "rambda";
import { useCallback } from "react";
import consts from "shared/consts";
import { syncServiceAtom } from "state-atoms";

type MondayIntegrationTemplates = "timeline";
export type IdKeyPair = KeyValuePair<string, string>[];

export const fixTimeLinesWithMondayItems = async (
  allElements: any[],
  syncService: any,
  ids: KeyValuePair<string, string>[]
) => {
  const oldIds = ids.map(([, oldId]) => oldId);
  const timeLinesToFix = allElements.filter(
    (e) =>
      e.type === consts.CANVAS_ELEMENTS.TIMELINE &&
      intersection(Object.keys(e.value.itemsDates ?? {}), oldIds).length > 0
  );

  await Promise.all(
    timeLinesToFix.flatMap((timeLine) => {
      // create a new mapping for the timeline so it will reference the new item
      const newItemsDates = Object.fromEntries(
        (Object.entries(timeLine.value.itemsDates) as [string, number][]).map(([itemId, value]) => {
          const currentItem = ids.find(([, oldId]) => oldId === itemId);
          return [currentItem?.[0] ?? itemId, value];
        })
      );

      syncService?.mutate.changeElements({
        info: [
          [
            `${consts.CANVAS_ELEMENTS.TIMELINE}-${timeLine.id}`,
            {
              itemsDates: newItemsDates,
            },
          ],
        ],
      });
    })
  );
};

const templateToAction: Record<
  MondayIntegrationTemplates,
  (allElements: any[], syncService: any, ids: IdKeyPair) => void
> = {
  timeline: fixTimeLinesWithMondayItems,
};

export const useFixTemplatesWithMondayItems = () => {
  const syncService = useAtomValue(syncServiceAtom);
  const { elements } = useCanvasElementsObjects(syncService?.getReplicache());

  return useCallback(
    (template: MondayIntegrationTemplates, ids: IdKeyPair) => {
      templateToAction[template](elements, syncService, ids);
    },
    [elements, syncService]
  );
};
